import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalComponent } from '../../../core/config/core.modal-helpers';
@Component({
    selector: 'frs-release-files',
    template: require('./frs.release.files.html')
})
export class FrsReleaseFilesComponent extends ModalComponent {
    @Input() release: any = null;
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() { super(); }
}